export const colorMapping: { [key: string]: string } = {
  undefined: "Clear",
  cyan: "Blue",
  "dark purple": "Purple",
  "bright red": "Red",
  "dark blonde": "Blonde",
  "medium blonde": "Blonde",
  "ginger orange": "Auburn",
  "light green": "Green",
  green: "Green",
  pink: "Pink",
  "brown black": "Brown",
  "medium brown": "Brown",
  orange: "Orange",
  "dark brown": "Brown",
  silver: "Silver",
  brown: "Brown",
  "light blonde": "Blonde",
  "light pink": "Pink",
  purple: "Purple",
  "black black": "Black",
  blonde: "Blonde",
  red: "Red",
  black: "Black",
  "light brown": "Brown",
  "caramel brown": "Brunette",
  blue: "Blue",
  yellow: "Yellow",
};
